'use client';

import { useCallback, useState } from 'react';
import { useLocation } from 'react-router';

import { AdminTopbar } from './admin-topbar';
import { AdminCommandPalette } from './admin-command-palette';

export interface AdminLayoutProps {
  children: React.ReactNode;
}

/**
 * Admin shell — topbar + page outlet. Sidebar/drawer chrome from the
 * previous design is gone; primary navigation is the topbar chips
 * (desktop) plus Dashboard's destination grid (mobile).
 *
 * Page chrome (title, description, sub-tabs, primary action) is now the
 * page's responsibility via the <AdminPage> primitive.
 */
export function AdminLayout({
  children,
}: AdminLayoutProps): React.ReactElement {
  const location = useLocation();
  const [paletteOpen, setPaletteOpen] = useState(false);

  const openPalette = useCallback(() => setPaletteOpen(true), []);

  if (location.pathname === '/admin/emergency') return <>{children}</>;

  return (
    <div className="min-h-screen bg-background">
      <AdminTopbar onOpenCommandPalette={openPalette} />
      <main className="mx-auto max-w-7xl px-3 pb-16 pt-6 sm:px-6 md:pt-8 lg:px-8">
        {children}
      </main>
      <AdminCommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
    </div>
  );
}

export default AdminLayout;
